<div class="c-form-field c-form-field--text-with-placeholders">
  <div class="c-form-field--text-with-placeholders--main">
    <p500-ui-text-field class="align-self-stretch" [formControl]="control" [label]="label"></p500-ui-text-field>
    <button p500-ui-text-button color="primary" class="font-headline-4" (click)="togglePlaceholders()">
      @if (showPlaceholders) {
      <span i18n="@@ui-kit.hide_placeholders">Hide Placeholders</span>
      } @else {
      <span i18n="@@ui-kit.show_placeholders">Show Placeholders</span>
      }
    </button>
  </div>
  @if (showPlaceholders) {
  <div class="c-form-field--text-with-placeholders--placeholders">
    <div class="c-form-field--text-with-placeholders--placeholders-description" i18n="@@offer_wizard.url_placeholders_description">
      Click on a placeholder to add it to the link as a parameter’s value. When lead opens this link, the placeholders are substituted with
      the actual values.
    </div>
    @if (customPlaceholders?.length || showExtraCustomParameter) {
    <div class="c-form-field--text-with-placeholders--placeholders-group">
      <div class="c-form-field--text-with-placeholders--placeholders-group-label" i18n="@@common.custom">Custom</div>
      <div class="c-form-field--text-with-placeholders--placeholders-group-body">
        @for (customPlaceholder of customPlaceholders.controls; track customPlaceholder; let i = $index) {
        <span class="c-form-field--text-with-placeholders--placeholder -custom" (click)="insertPlaceholder('{free_' + (i + 1) + '}')">
          {{ '{free_' + (i + 1) + '}' }}
        </span>
        } @if (showExtraCustomParameter) {
        <span
          class="c-form-field--text-with-placeholders--placeholder -custom"
          (click)="insertPlaceholder('{free_' + (customPlaceholders.controls.length + 1) + '}')"
        >
          {{ '{free_' + (customPlaceholders.controls.length + 1) + '}' }}
        </span>
        }
      </div>
    </div>
    } @for (key of groups; track key) {
    <div class="c-form-field--text-with-placeholders--placeholders-group">
      <div class="c-form-field--text-with-placeholders--placeholders-group-label">{{ placeholderGroupsLabels[key] }}</div>
      <div class="c-form-field--text-with-placeholders--placeholders-group-body">
        @for (placeholder of placeholders[key]; track placeholder) {
        <span class="c-form-field--text-with-placeholders--placeholder" (click)="insertPlaceholder('{' + placeholder + '}')">
          {{ '{' + placeholder + '}' }}
        </span>
        }
      </div>
    </div>
    }
  </div>
  }
</div>
